export enum UserSecurityFormLabels {
  Show = "Show",
  Hide = "Hide",
  Roles = "Roles",
  ShowOnCalendar = "Show user on appointment book",
  HasScheduledAppointment = "This user has scheduled appointments. We recommend rescheduling future appointments before removing the user from calendar."
}
